import React, { lazy } from "react";
import { connect, DispatchProp } from "react-redux";
import IAction from "../../../models/IAction";
import IStore from "../../../models/IStore";
import MenuModel from "stores/menu/models/MenuModel";
import { Route, Switch } from "react-router-dom";
import MenuAction from "stores/menu/MenuAction";
import { selectRequesting } from "selectors/requesting/RequestingSelector";
import RouteEnum from "constants/RouteEnum";

const BaseContent = lazy(() => import("views/components/base-content/BaseContent"));
const PrivacyPage = lazy(() => import("views/privacy/PrivacyPage"));
const NotFoundPage = lazy(() => import("views/not-found-page/NotFoundPage"));
const PreventivoPage = lazy(() => import("views/preventivo-page/PreventivoPage"));
const AccessoRegistrazionePage = lazy(() => import("views/accesso-registrazione-page/AccessoRegistrazionePage"));
const AccessoPage = lazy(() => import("views/accesso-page/AccessoPage"));
const AccessoEffettuatoPage = lazy(() => import("views/accesso-effettuato-page/AccessoEffettuatoPage"));
const RegistrazioneConfermaEmailPage = lazy(
    () => import("views/registrazione-conferma-email-page/RegistrazioneConfermaEmailPage")
);
const RegistrazioneEffettuataPage = lazy(
    () => import("views/registrazione-effettuata-page/RegistrazioneEffettuataPage")
);
const DashboardPage = lazy(() => import("views/dashboard-page/DashboardPage"));
const RichiestaPage = lazy(() => import("views/richiesta-page/RichiestaPage"));
const RecuperoPasswordPage = lazy(() => import("views/recupero-password-page/RecuperoPasswordPage"));
const CambioPasswordPage = lazy(() => import("views/cambio-password-page/CambioPasswordPage"));
const DocumentiIstruttoriaPage = lazy(() => import("views/documenti-istruttoria-page/DocumentiIstruttoriaPage"));
const RichiestaPreventivoPage = lazy(() => import("views/richiesta-preventivo-page/RichiestaPreventivoPage"));
const HomePage = lazy(() => import("views/home-page/HomePage"))
interface IProps {}
interface IState {
    readonly sitePaths: MenuModel[];
}
interface IStateToProps {
    readonly isRequesting: boolean;
    readonly sitePaths: MenuModel[];
}

const mapStateToProps = (state: IStore, ownProps: IProps): IStateToProps => ({
    isRequesting: selectRequesting(state, [MenuAction.REQUEST_PATHS]),
    sitePaths: state.menu.sitePaths,
});

class BasePath extends React.Component<IProps & IStateToProps & DispatchProp<IAction<any>>, IState> {
    constructor(props: IProps & IStateToProps & DispatchProp<IAction<any>>) {
        super(props);
        this.state = {
            sitePaths: [],
        } as IState;
    }

    private hasUnmounted = false;

    public componentDidMount() {
        this.setLookupsAndViewModel();
    }

    public componentWillUnmount() {
        this.hasUnmounted = true;
    }

    private setLookupsAndViewModel = async () => {
        let sitePaths: MenuModel[] = await this.props.dispatch(MenuAction.requestPaths());
        if (this.hasUnmounted === false) {
            this.setState({
                sitePaths: sitePaths,
            });
        }
    };

    public render(): JSX.Element {
        const { sitePaths } = this.state;

        return (
            <Switch>
                <Route exact={true} path={RouteEnum().HOME} component={HomePage} />               
                <Route exact={true} path={RouteEnum().PRIVACY} component={PrivacyPage} />
                <Route exact={true} path={RouteEnum().PREVENTIVO} component={PreventivoPage} />
                <Route exact={true} path={RouteEnum().ACCESSO_REGISTRAZIONE} component={AccessoRegistrazionePage} />
                <Route
                    exact={true}
                    path={RouteEnum().REGISTRAZIONE_EFFETTUATA}
                    component={RegistrazioneEffettuataPage}
                />
                <Route
                    exact={true}
                    path={RouteEnum().CONFERMA_REGISTRAZIONE}
                    component={RegistrazioneConfermaEmailPage}
                />
                <Route exact={true} path={RouteEnum().ACCESSO} component={AccessoPage} />
                <Route exact={true} path={RouteEnum().ACCESSO_EFFETTUATO} component={AccessoEffettuatoPage} />
                <Route exact={true} path={RouteEnum().RECUPERO_PASSWORD} component={RecuperoPasswordPage} />
                <Route exact={true} path={RouteEnum().CAMBIO_PASSWORD} component={CambioPasswordPage} />
                <Route exact={true} path={RouteEnum().DASHBOARD} component={DashboardPage} />
                <Route exact={true} path={RouteEnum().RICHIESTA} component={RichiestaPage} />
                <Route
                    exact={true}
                    path={RouteEnum().FIRMA_DOCUMENTI_ISTRUTTORIA}
                    component={DocumentiIstruttoriaPage}
                />
                <Route exact={true} path={RouteEnum().RICHIESTA_PREVENTIVO} component={RichiestaPreventivoPage} />
                {sitePaths && sitePaths.length > 0
                    ? sitePaths.map((sitePath) => (
                          <Route
                              key={sitePath.idVoceMenu}
                              exact={true}
                              path={"/" + sitePath.path}
                              component={() => (
                                  <BaseContent
                                      contentCode={sitePath.codiceContenuto}
                                      positionId={sitePath.idElemento}
                                  />
                              )}
                          />
                      ))
                    : null}
                <Route component={NotFoundPage} />
            </Switch>
        );
    }
}

export { BasePath as Unconnected };
export default connect(mapStateToProps)(BasePath);
